module.exports = {"validation":{"required":"Questo campo è obbligatorio","email":"Indirizzo e-mail non valido"}}